const en = {
  'English': 'English',
  'Hindi': 'Hindi',
  'Marathi': 'Marathi',
  'Dashboard': 'Dashboard',
  'Network': 'Network',
  'Leads': 'Leads',
  'Learning Center': 'Learning Center',
  'Platform Tour': 'Platform Tour',
  'About Us': 'About Us',
  'Offline': 'Offline',
  'Notifications': 'Notifications',
  'Notifications ({count} unread)': 'Notifications ({count} unread)',
  'Loading notifications...': 'Loading notifications...',
  'No new notifications': 'No new notifications',
  'Mark all as read': 'Mark all as read',
  'Hi, {name}': 'Hi, {name}',
  'My Profile': 'My Profile',
  'Scan Attendance QR': 'Scan Attendance QR',
  'Android App': 'Android App',
  'Settings': 'Settings',
  'Platform Invoices': 'Platform Invoices',
  'Convert To Customer': 'Convert To Customer',
  'Force Refresh App': 'Force Refresh App',
  'Logout': 'Logout',
  'This will clear all cached data and refresh the app. Continue?': 'This will clear all cached data and refresh the app. Continue?',
  'Preparing Android app download...': 'Preparing Android app download...',
  'Downloading Android app... {percent}%': 'Downloading Android app... {percent}%',
  'Downloading Android app...': 'Downloading Android app...',
  'Android app download started.': 'Android app download started.',
  'Android app download timed out. Please try again.': 'Android app download timed out. Please try again.',
  'Failed to download Android app. Please try again.': 'Failed to download Android app. Please try again.',
  'Install CalorieNSweat App': 'Install CalorieNSweat App',
  'Add to your home screen for quick access': 'Add to your home screen for quick access',
  'Later': 'Later',
  'Install': 'Install',
  'Built with affection': 'Built with affection',
  'by': 'by',
  'Welcome, {name}!': 'Welcome, {name}!',
  'Reset Password': 'Reset Password',
  'Email Address': 'Email Address',
  'Email Address or Username': 'Email Address or Username',
  'Enter email or username': 'Enter email or username',
  'Enter your email address': 'Enter your email address',
  'Password': 'Password',
  'Hide password': 'Hide password',
  'Show password': 'Show password',
  'Please complete the reCAPTCHA verification': 'Please complete the reCAPTCHA verification',
  'reCAPTCHA not available on localhost. This is normal for development.': 'reCAPTCHA not available on localhost. This is normal for development.',
  'reCAPTCHA verification failed. Please refresh the page and try again.': 'reCAPTCHA verification failed. Please refresh the page and try again.',
  'Login': 'Login',
  'Logging in...': 'Logging in...',
  'Forgot Password?': 'Forgot Password?',
  'Forgot your password?': 'Forgot your password?',
  'Contact your administrator for account access': 'Contact your administrator for account access',
  'By using CalorienSweat, you agree to our:': 'By using CalorienSweat, you agree to our:',
  'Privacy Policy': 'Privacy Policy',
  'Terms of Service': 'Terms of Service',
  'Signing in...': 'Signing in...',
  'Sign In': 'Sign In',
  'Sending...': 'Sending...',
  'Send Reset Link': 'Send Reset Link',
  'Back to Login': 'Back to Login',
  'Invalid or missing reset token.': 'Invalid or missing reset token.',
  'Invalid or expired reset token.': 'Invalid or expired reset token.',
  'Passwords do not match.': 'Passwords do not match.',
  'Password must be at least 6 characters long.': 'Password must be at least 6 characters long.',
  'Failed to reset password. Please try again.': 'Failed to reset password. Please try again.',
  'Invalid Reset Link': 'Invalid Reset Link',
  'Request New Reset Link': 'Request New Reset Link',
  'Password Reset Successful!': 'Password Reset Successful!',
  'Your password has been successfully reset. You will be redirected to the login page in a few seconds.': 'Your password has been successfully reset. You will be redirected to the login page in a few seconds.',
  'Go to Login': 'Go to Login',
  'Verifying reset link...': 'Verifying reset link...',
  'Set New Password': 'Set New Password',
  'New Password': 'New Password',
  'Enter new password (min 6 characters)': 'Enter new password (min 6 characters)',
  'Confirm New Password': 'Confirm New Password',
  'Confirm new password': 'Confirm new password',
  'Resetting...': 'Resetting...',
  'If your email is registered with us, you will receive a password reset link.': 'If your email is registered with us, you will receive a password reset link.',
  'Reports': 'Reports',
  'Please select both start and end dates': 'Please select both start and end dates',
  'Date range cannot exceed more than one year': 'Date range cannot exceed more than one year',
  'Start date cannot be after end date': 'Start date cannot be after end date',
  'Failed to generate report. Please try again.': 'Failed to generate report. Please try again.',
  'Failed to generate attendance report. Please try again.': 'Failed to generate attendance report. Please try again.',
  'Failed to generate profit report. Please try again.': 'Failed to generate profit report. Please try again.',
  'Failed to export attendance report. Please try again.': 'Failed to export attendance report. Please try again.',
  'No data to export': 'No data to export',
  'Reports Dashboard': 'Reports Dashboard',
  'Generate detailed reports for your business analysis': 'Generate detailed reports for your business analysis',
  'Available Reports': 'Available Reports',
  'Invoice Reports': 'Invoice Reports',
  'Generate detailed invoice reports with payment information, GST breakdown, and volume points': 'Generate detailed invoice reports with payment information, GST breakdown, and volume points',
  'Attendance Reports': 'Attendance Reports',
  'Generate monthly attendance reports for your club customers': 'Generate monthly attendance reports for your club customers',
  'Profit Reports': 'Profit Reports',
  'Analyze profit margins and volume points distribution across products and programs': 'Analyze profit margins and volume points distribution across products and programs',
  'More Reports Coming Soon': 'More Reports Coming Soon',
  'Additional report types will be added in future updates': 'Additional report types will be added in future updates',
  'Invoice Report Generator': 'Invoice Report Generator',
  'Program Invoice': 'Program Invoice',
  'Product Invoice': 'Product Invoice',
  'GST will not be charged or shown because your company GSTIN is not configured.': 'GST will not be charged or shown because your company GSTIN is not configured.',
  'Maximum shipping charges allowed: ₹300. GST will not be charged.': 'Maximum shipping charges allowed: ₹300. GST will not be charged.',
  'Generating...': 'Generating...',
  'Generate Report': 'Generate Report',
  'Export CSV': 'Export CSV',
  'Note: Date range cannot exceed more than one year': 'Note: Date range cannot exceed more than one year',
  'Invoice Report Results ({count} entries)': 'Invoice Report Results ({count} entries)',
  'Period': 'Period',
  'Invoice ID': 'Invoice ID',
  'Invoice Date': 'Invoice Date',
  'Customer Name': 'Customer Name',
  'Mode of Payment': 'Mode of Payment',
  'CGST Amount': 'CGST Amount',
  'SGST Amount': 'SGST Amount',
  'Total of Invoice': 'Total of Invoice',
  'GST Codes': 'GST Codes',
  'Report Summary': 'Report Summary',
  'Total Entries': 'Total Entries',
  'Total Payments': 'Total Payments',
  'Total CGST': 'Total CGST',
  'Total SGST': 'Total SGST',
  'Attendance Report Generator': 'Attendance Report Generator',
  'Month': 'Month',
  'Year': 'Year',
  'Attendance Summary ({count} customers)': 'Attendance Summary ({count} customers)',
  'Present Days': 'Present Days',
  'Absent Days': 'Absent Days',
  'Attendance %': 'Attendance %',
  'Total Customers': 'Total Customers',
  'Total Present': 'Total Present',
  'Total Absent': 'Total Absent',
  'Days in Month': 'Days in Month',
  'Profit & Volume Points Report': 'Profit & Volume Points Report',
  'Profit Analysis Report': 'Profit Analysis Report',
  'Total Profit': 'Total Profit',
  'Total Volume Points': 'Total Volume Points',
  'Total Cost to Company': 'Total Cost to Company',
  'Revenue in Pipeline': 'Revenue in Pipeline',
  'Sales in Pipeline': 'Sales in Pipeline',
  'Product Cost': 'Product Cost',
  'Program Cost': 'Program Cost',
  'Program Renewal Profit': 'Program Renewal Profit',
  'Program Renewal Sales': 'Program Renewal Sales',
  'Payment Due': 'Payment Due',
  'Membership Discounts': 'Membership Discounts',
  'Custom Discounts': 'Custom Discounts',
  'Profit Distribution': 'Profit Distribution',
  'No profit data available for this period': 'No profit data available for this period',
  'Product Sales': 'Product Sales',
  'Program Sales': 'Program Sales',
  'Service Sales': 'Service Sales',
  'Services': 'Services',
  'Volume Points Distribution': 'Volume Points Distribution',
  'No volume points data available for this period': 'No volume points data available for this period',
  'Discount Distribution': 'Discount Distribution',
  'No discount data available for this period': 'No discount data available for this period',
  'Detailed Breakdown': 'Detailed Breakdown',
  'Profit Margins': 'Profit Margins',
  'Discount Breakdown': 'Discount Breakdown',
  'Cost to Company Breakdown': 'Cost to Company Breakdown',
  'Pipeline Breakdown': 'Pipeline Breakdown',
  'Program Renewal Revenue': 'Program Renewal Revenue',
  'Pending Dues': 'Pending Dues',
  'Total Pipeline Revenue': 'Total Pipeline Revenue',
  'Membership': 'Membership',
  'Custom': 'Custom',
  'My Customers': 'My Customers',
  'Affiliated Customers': 'Affiliated Customers',
  'From affiliated clubs': 'From affiliated clubs',
  'First Line Supervisors': 'First Line Supervisors',
  'All Line Supervisors': 'All Line Supervisors',
  'Org Tree View': 'Org Tree View',
  "Today's Checkup": "Today's Checkup",
  "Today's Birthday": "Today's Birthday",
  "Today's Followups": "Today's Followups",
  "Today's Lead Followups": "Today's Lead Followups",
  'Upcoming Followups': 'Upcoming Followups',
  'Upcoming Followups (Next 7 Days)': 'Upcoming Followups (Next 7 Days)',
  'Customer Followup': 'Customer Followup',
  'Lead Followup': 'Lead Followup',
  'Customer Acquisition': 'Customer Acquisition',
  'Customer Acquisition Report': 'Customer Acquisition Report',
  'Analyze customer growth from actively subscribed coaches across your hierarchy': 'Analyze customer growth from actively subscribed coaches across your hierarchy',
  'Track new customers by month and coach ownership.': 'Track new customers by month and coach ownership.',
  'Report Scope': 'Report Scope',
  'Self': 'Self',
  'Org': 'Org',
  'My customers (active subscription)': 'My customers (active subscription)',
  "Customers of active descendant coaches": "Customers of active descendant coaches",
  'From Month': 'From Month',
  'To Month': 'To Month',
  'Start month cannot be after end month': 'Start month cannot be after end month',
  'Failed to generate customer acquisition report. Please try again.': 'Failed to generate customer acquisition report. Please try again.',
  'New Customers': 'New Customers',
  'Monthly Average': 'Monthly Average',
  'Leading Coach': 'Leading Coach',
  'Selected Period': 'Selected Period',
  'Monthly Acquisition Trend': 'Monthly Acquisition Trend',
  'New customers created in each selected month': 'New customers created in each selected month',
  'Monthly customer acquisition bar chart': 'Monthly customer acquisition bar chart',
  'Acquisition by Coach': 'Acquisition by Coach',
  'Contribution across the complete coach hierarchy': 'Contribution across the complete coach hierarchy',
  'No descendant coaches found.': 'No descendant coaches found.',
  'New Customer Details': 'New Customer Details',
  '{count} customers in the selected period': '{count} customers in the selected period',
  'No new customers found for the selected period and scope.': 'No new customers found for the selected period and scope.',
  'Contact': 'Contact',
  'Coach': 'Coach',
  'Online': 'Online',
  'Online Clients': 'Online Clients',
  'Club Clients': 'Club Clients',
  'Type Not Set': 'Type Not Set',
  'Not Set': 'Not Set',
  'Customer type legend': 'Customer type legend',
  'Renewal Due': 'Renewal Due',
  'Renewal Due (Next 7 Days)': 'Renewal Due (Next 7 Days)',
  'Due Payments': 'Due Payments',
  'QR Attendance Marker': 'QR Attendance Marker',
  'Generate QR for attendance': 'Generate QR for attendance',
  'Attendance Marker': 'Attendance Marker',
  'Failed to generate QR code. Please ensure your company information is set up.': 'Failed to generate QR code. Please ensure your company information is set up.',
  'Failed to load customers. Please try again.': 'Failed to load customers. Please try again.',
  'Failed to download instructions PDF. Please try again.': 'Failed to download instructions PDF. Please try again.',
  'Failed to mark attendance for today. Please try again.': 'Failed to mark attendance for today. Please try again.',
  'Please select a customer and at least one date': 'Please select a customer and at least one date',
  'Attendance marked successfully for selected dates!': 'Attendance marked successfully for selected dates!',
  'Attendance de-marked successfully for selected dates!': 'Attendance de-marked successfully for selected dates!',
  'Failed to mark attendance. Please try again.': 'Failed to mark attendance. Please try again.',
  'Failed to de-mark attendance. Please try again.': 'Failed to de-mark attendance. Please try again.',
  'Generating attendance QR code...': 'Generating attendance QR code...',
  'Attendance QR Code': 'Attendance QR Code',
  'QR Code Details': 'QR Code Details',
  "Today's Date": "Today's Date",
  'Permanent QR. No daily printing required.': 'Permanent QR. No daily printing required.',
  'Download Instructions PDF': 'Download Instructions PDF',
  'Mark Attendance': 'Mark Attendance',
  'De-Mark Attendance': 'De-Mark Attendance',
  'Permanent QR Code - Valid Every Day': 'Permanent QR Code - Valid Every Day',
  'Customers Present Today ({count})': 'Customers Present Today ({count})',
  'Search present...': 'Search present...',
  'No matching attendance found.': 'No matching attendance found.',
  'No attendance recorded yet for today.': 'No attendance recorded yet for today.',
  'Present': 'Present',
  'Yet To Mark Today ({count})': 'Yet To Mark Today ({count})',
  'Search pending...': 'Search pending...',
  'No matching customers found.': 'No matching customers found.',
  'All active club customers have marked attendance today.': 'All active club customers have marked attendance today.',
  'Marking...': 'Marking...',
  'Mark Today': 'Mark Today',
  'Manually Mark Attendance': 'Manually Mark Attendance',
  'Manually De-Mark Attendance': 'Manually De-Mark Attendance',
  'Search Customer': 'Search Customer',
  'Search by name, email, or phone...': 'Search by name, email, or phone...',
  'Selected Customer': 'Selected Customer',
  'Select Date(s)': 'Select Date(s)',
  'Selected Dates ({count})': 'Selected Dates ({count})',
  'De-marking...': 'De-marking...',
  'Scan Attendance QR': 'Scan Attendance QR',
  'Product Management': 'Product Management',
  'Document Management': 'Document Management',
  'Access Management': 'Access Management',
  'Pending Promotion Requests': 'Pending Promotion Requests',
  'Lead Management': 'Lead Management',
  'Meal Plan Templates': 'Meal Plan Templates',
  'Training Videos Management': 'Training Videos Management',
  'Leaderboard': 'Leaderboard',
  'Challenge Management': 'Challenge Management',
  'Challenges': 'Challenges',
  'My Dashboard': 'My Dashboard',
  'Manage Associates': 'Manage Associates',
  'Platform Invoices Management': 'Platform Invoices Management',
  'Subscription Invoices Management': 'Subscription Invoices Management',
  'Language': 'Language',
  'Toggle mobile menu': 'Toggle mobile menu',
  'Close': 'Close',
  'Cancel': 'Cancel',
  'Save': 'Save',
  'Save Changes': 'Save Changes',
  'Saving...': 'Saving...',
  'Add': 'Add',
  'Add More': 'Add More',
  'Edit': 'Edit',
  'Delete': 'Delete',
  'Deleting...': 'Deleting...',
  'Remove': 'Remove',
  'Refresh': 'Refresh',
  'Retry': 'Retry',
  'Submit': 'Submit',
  'Search': 'Search',
  'Search...': 'Search...',
  'Type to search...': 'Type to search...',
  'Clear selection': 'Clear selection',
  'Actions': 'Actions',
  'Action': 'Action',
  'Status': 'Status',
  'Active': 'Active',
  'Inactive': 'Inactive',
  'Archived': 'Archived',
  'Pending': 'Pending',
  'Approved': 'Approved',
  'Rejected': 'Rejected',
  'Customer': 'Customer',
  'Customers': 'Customers',
  'Member': 'Member',
  'Members': 'Members',
  'Participant': 'Participant',
  'Participants': 'Participants',
  'Name': 'Name',
  'First Name': 'First Name',
  'Last Name': 'Last Name',
  'Username': 'Username',
  'Gender': 'Gender',
  'Phone': 'Phone',
  'Address': 'Address',
  'Age': 'Age',
  'Date of Birth': 'Date of Birth',
  'Weight': 'Weight',
  'Height': 'Height',
  'Email': 'Email',
  'Type': 'Type',
  'Description': 'Description',
  'Category': 'Category',
  'Amount': 'Amount',
  'Notes': 'Notes',
  'Date': 'Date',
  'Created': 'Created',
  'Uploaded': 'Uploaded',
  'Joined': 'Joined',
  'Start Date': 'Start Date',
  'End Date': 'End Date',
  'Program': 'Program',
  'Programs': 'Programs',
  'Health Readings': 'Health Readings',
  'Invoices': 'Invoices',
  'Health Reports': 'Health Reports',
  'Meal Plan': 'Meal Plan',
  'Referrals': 'Referrals',
  'Loading customer details...': 'Loading customer details...',
  'Back to Customers': 'Back to Customers',
  'Customer Details': 'Customer Details',
  'Customer Information': 'Customer Information',
  'Promote To Coach': 'Promote To Coach',
  'Club Change': 'Club Change',
  'Edit Customer': 'Edit Customer',
  'Personal Details': 'Personal Details',
  'Account Details': 'Account Details',
  'Program Details': 'Program Details',
  'GST Number': 'GST Number',
  'Discomforts & Medications': 'Discomforts & Medications',
  'PC ID/Associate ID': 'PC ID/Associate ID',
  'Referred By': 'Referred By',
  'Active Program': 'Active Program',
  'No Active Program': 'No Active Program',
  'Checkup Day': 'Checkup Day',
  'Program Discount': 'Program Discount',
  'Product Discount': 'Product Discount',
  'Basic': 'Basic',
  'Basic (MRP)': 'Basic (MRP)',
  'N/A': 'N/A',
  'Failed to load your details. Please try again.': 'Failed to load your details. Please try again.',
  'Meal plan link is missing': 'Meal plan link is missing',
  'Failed to open meal plan. Please try again.': 'Failed to open meal plan. Please try again.',
  'Failed to download document. Please try again.': 'Failed to download document. Please try again.',
  'Failed to download invoice. Please try again.': 'Failed to download invoice. Please try again.',
  'Failed to download health report. Please try again.': 'Failed to download health report. Please try again.',
  'Reading date and weight are required.': 'Reading date and weight are required.',
  'Failed to add health reading. Please try again.': 'Failed to add health reading. Please try again.',
  'Loading your dashboard...': 'Loading your dashboard...',
  'My Information': 'My Information',
  'Email': 'Email',
  'Phone': 'Phone',
  'Gender': 'Gender',
  'Address': 'Address',
  'Customer Type': 'Customer Type',
  'ONLINE': 'ONLINE',
  'CLUB': 'CLUB',
  'MALE': 'MALE',
  'FEMALE': 'FEMALE',
  'ACTIVE': 'ACTIVE',
  'INACTIVE': 'INACTIVE',
  'BLOCKED': 'BLOCKED',
  'PAID': 'PAID',
  'PENDING': 'PENDING',
  'OVERDUE': 'OVERDUE',
  'CANCELLED': 'CANCELLED',
  'My Health Readings': 'My Health Readings',
  'Add Reading': 'Add Reading',
  'No health readings found. Click "Add Reading" to record your first health reading.': 'No health readings found. Click "Add Reading" to record your first health reading.',
  'No health readings found. Your coach will add readings after your checkups.': 'No health readings found. Your coach will add readings after your checkups.',
  'Weight (kg)': 'Weight (kg)',
  'Visceral Fat': 'Visceral Fat',
  'Total Fat (%)': 'Total Fat (%)',
  'Meta Age': 'Meta Age',
  'Skeletal Muscle (%)': 'Skeletal Muscle (%)',
  'TSF': 'TSF',
  'TSF (mm)': 'TSF (mm)',
  'Date': 'Date',
  'Description': 'Description',
  'Amount': 'Amount',
  'Due Date': 'Due Date',
  'Actions': 'Actions',
  '{count} payment(s) • Balance: ₹{amount}': '{count} payment(s) • Balance: ₹{amount}',
  'Paid: ₹{amount}': 'Paid: ₹{amount}',
  'Download PDF': 'Download PDF',
  'Download': 'Download',
  'My Invoices': 'My Invoices',
  'No invoices found.': 'No invoices found.',
  'Referals': 'Referals',
  'My Referals': 'My Referals',
  'Loading referals...': 'Loading referals...',
  'No referals found.': 'No referals found.',
  'Name': 'Name',
  'My Health Library': 'My Health Library',
  'Access documents and resources for {customerType} members': 'Access documents and resources for {customerType} members',
  'Loading documents...': 'Loading documents...',
  'No documents available for {customerType} members at the moment.': 'No documents available for {customerType} members at the moment.',
  'Health Videos ({count})': 'Health Videos ({count})',
  'Added by {name} • {date}': 'Added by {name} • {date}',
  'Watch Video': 'Watch Video',
  'Watch': 'Watch',
  'Documents ({count})': 'Documents ({count})',
  'Document': 'Document',
  'Category': 'Category',
  'Action': 'Action',
  'No description': 'No description',
  'Download Document': 'Download Document',
  'No documents or videos available for {customerType} members at the moment.': 'No documents or videos available for {customerType} members at the moment.',
  'No health reports found. Your coach will generate reports based on your health readings.': 'No health reports found. Your coach will generate reports based on your health readings.',
  'No programs assigned yet. Your coach will assign programs based on your goals.': 'No programs assigned yet. Your coach will assign programs based on your goals.',
  'My Cashback Wallet': 'My Cashback Wallet',
  'Total Earned: ₹{earned} | Total Used: ₹{used}': 'Total Earned: ₹{earned} | Total Used: ₹{used}',
  'Loading cashback data...': 'Loading cashback data...',
  'Cashback Earned ({count})': 'Cashback Earned ({count})',
  'No cashback earned yet. Refer friends to earn cashback!': 'No cashback earned yet. Refer friends to earn cashback!',
  'Referral': 'Referral',
  'Cashback Used ({count})': 'Cashback Used ({count})',
  'No cashback used yet.': 'No cashback used yet.',
  'Used for Invoice': 'Used for Invoice',
  'No meal plans assigned yet. Your coach will assign meal plans based on your goals and preferences.': 'No meal plans assigned yet. Your coach will assign meal plans based on your goals and preferences.',
  'Open': 'Open',
  'Reading Date': 'Reading Date',
  'BMR (kcal)': 'BMR (kcal)',
  'Metabolic Age': 'Metabolic Age',
  'Male Leaders': 'Male Leaders',
  'Female Leaders': 'Female Leaders',
  'Online Male Leaders': 'Online Male Leaders',
  'Club Male Leaders': 'Club Male Leaders',
  'Online Female Leaders': 'Online Female Leaders',
  'Club Female Leaders': 'Club Female Leaders',
  'Full leaderboard list ranked by {metric} for this category.': 'Full leaderboard list ranked by {metric} for this category.',
  'weight loss': 'weight loss',
  'percentage of weight loss': 'percentage of weight loss',
  'Best Weight Loss': 'Best Weight Loss',
  'Best % Loss': 'Best % Loss',
  'Loading members...': 'Loading members...',
  'No members found for this category.': 'No members found for this category.',
  'Latest three weight entries are shown as week1, week2, and week3.': 'Latest three weight entries are shown as week1, week2, and week3.',
  'Total': 'Total',
  'Rank': 'Rank',
  'Participant': 'Participant',
  'Start Weight': 'Start Weight',
  'End Weight': 'End Weight',
  'Weight Loss': 'Weight Loss',
  '% Loss': '% Loss',
  'Week1': 'Week1',
  'Week2': 'Week2',
  'Week3': 'Week3',
  'Top 3 Transformation Leaders': 'Top 3 Transformation Leaders',
  'Premium podium view for the strongest weight-loss results in this challenge category.': 'Premium podium view for the strongest weight-loss results in this challenge category.',
  'Rank #{rank}': 'Rank #{rank}',
  'Drill down': 'Drill down',
  'Loading leaders...': 'Loading leaders...',
  'No qualifying customers found for this range.': 'No qualifying customers found for this range.',
  'Loss': 'Loss',
  'ALL': 'ALL',
  'Failed to load leaderboard.': 'Failed to load leaderboard.',
  'Failed to load members.': 'Failed to load members.',
  'Leaderboard Details': 'Leaderboard Details',
  'Track top customer weight loss in the challenge leaderboard.': 'Track top customer weight loss in the challenge leaderboard.',
  'Track top customer weight loss across club, org, and challenge views.': 'Track top customer weight loss across club, org, and challenge views.',
  'Club Level': 'Club Level',
  'Org Level': 'Org Level',
  'Challenge Level': 'Challenge Level',
  'Challenge Date Range': 'Challenge Date Range',
  'Select a challenge': 'Select a challenge',
  'Loading challenges...': 'Loading challenges...',
  'No challenges available.': 'No challenges available.',
  'Club Level Leaders': 'Club Level Leaders',
  'Org Level Leaders': 'Org Level Leaders',
  'Back to Dashboard': 'Back to Dashboard',
  'Reshare Invoice on WhatsApp': 'Reshare Invoice on WhatsApp',
  'Invoice reshared successfully over WhatsApp.': 'Invoice reshared successfully over WhatsApp.',
  'Failed to reshare invoice over WhatsApp. Please try again.': 'Failed to reshare invoice over WhatsApp. Please try again.',
  'years': 'years',
  'Customer Meal Plans': 'Customer Meal Plans',
  'Add Meal Plan': 'Add Meal Plan',
  'Loading meal plans...': 'Loading meal plans...',
  'No meal plans found. Click "Add Meal Plan" to create the first meal plan.': 'No meal plans found. Click "Add Meal Plan" to create the first meal plan.',
  'Customer Referrals': 'Customer Referrals',
  'Loading referrals...': 'Loading referrals...',
  'No referrals found for this customer.': 'No referrals found for this customer.',
  'Health Readings History': 'Health Readings History',
  'Log Monitoring': 'Log Monitoring',
  'Generate Health Report': 'Generate Health Report',
  'Loading health readings...': 'Loading health readings...',
  'No health readings found. Click "Add Health Reading" to add the first reading.': 'No health readings found. Click "Add Health Reading" to add the first reading.',
  'Customer Invoices': 'Customer Invoices',
  'Add Invoice': 'Add Invoice',
  'Loading invoices...': 'Loading invoices...',
  'No invoices found. Click "Add Invoice" to create the first invoice.': 'No invoices found. Click "Add Invoice" to create the first invoice.',
  'Loading health reports...': 'Loading health reports...',
  'No health reports found. Generate your first AI-powered health report from the Health Readings tab.': 'No health reports found. Generate your first AI-powered health report from the Health Readings tab.',
  'Assigned Programs': 'Assigned Programs',
  'Assign Program': 'Assign Program',
  'Loading programs...': 'Loading programs...',
  'No programs assigned yet. Click "Assign Program" to assign the first program.': 'No programs assigned yet. Click "Assign Program" to assign the first program.',
  'Create Meal Plan for {name}': 'Create Meal Plan for {name}',
  'Select Criteria': 'Select Criteria',
  'User data not available. Please try again.': 'User data not available. Please try again.',
  'Failed to load complete profile data. Some fields may be empty.': 'Failed to load complete profile data. Some fields may be empty.',
  'This email address is already registered': 'This email address is already registered',
  'This username is already registered': 'This username is already registered',
  'Please fix the email validation error before submitting.': 'Please fix the email validation error before submitting.',
  'Please fix the username validation error before submitting.': 'Please fix the username validation error before submitting.',
  'Failed to update profile. Please try again.': 'Failed to update profile. Please try again.',
  'Profile Updated Successfully!': 'Profile Updated Successfully!',
  'Your profile information has been updated.': 'Your profile information has been updated.',
  'Loading profile data...': 'Loading profile data...',
  'New Password (leave blank to keep current)': 'New Password (leave blank to keep current)',
  'Updating...': 'Updating...',
  'Update Profile': 'Update Profile',
  "Failed to load today's attendance status. Please try again.": "Failed to load today's attendance status. Please try again.",
  'Please select an image file (PNG, JPG, GIF)': 'Please select an image file (PNG, JPG, GIF)',
  'Logo file size must be less than 5MB': 'Logo file size must be less than 5MB',
  'Logo will be automatically resized to fit within 240x240 pixels': 'Logo will be automatically resized to fit within 240x240 pixels',
  'Invalid FSSAI number': 'Invalid FSSAI number',
  'Failed to save company information. Please try again.': 'Failed to save company information. Please try again.',
  'Are you sure you want to delete the company logo?': 'Are you sure you want to delete the company logo?',
  'Logo deleted successfully': 'Logo deleted successfully',
  'Failed to delete logo. Please try again.': 'Failed to delete logo. Please try again.',
  'Failed to save club affiliation. Please try again.': 'Failed to save club affiliation. Please try again.',
  'Company Information Saved Successfully!': 'Company Information Saved Successfully!',
  'Club Affiliation Updated Successfully!': 'Club Affiliation Updated Successfully!',
  'Your company information has been updated.': 'Your company information has been updated.',
  'Your club affiliation has been updated.': 'Your club affiliation has been updated.',
  "Today's Attendance": "Today's Attendance",
  "Loading today's attendance...": "Loading today's attendance...",
  'Marked At': 'Marked At',
  'Company Setup Required': 'Company Setup Required',
  'Please complete your company information to continue using the platform. This information is required for invoice generation and compliance.': 'Please complete your company information to continue using the platform. This information is required for invoice generation and compliance.',
  'Complete Setup & Continue': 'Complete Setup & Continue',
  'Save Company Information': 'Save Company Information',
  'My Company': 'My Company',
  'Club Affiliation': 'Club Affiliation',
  'Club Affiliation Settings': 'Club Affiliation Settings',
  'Club Ownership Type': 'Club Ownership Type',
  'Intern Club Owner': 'Intern Club Owner',
  'Select Club Owner': 'Select Club Owner',
  'Select a club owner': 'Select a club owner',
  'Select the club owner you are affiliated with': 'Select the club owner you are affiliated with',
  'Current Club Affiliation': 'Current Club Affiliation',
  'Affiliated with': 'Affiliated with',
  'You are operating as an independent club owner': 'You are operating as an independent club owner',
  'About Club Affiliation': 'About Club Affiliation',
  'You operate independently and manage your own club': 'You operate independently and manage your own club',
  'You are affiliated with another club owner and operate under their guidance': 'You are affiliated with another club owner and operate under their guidance',
  'Save Affiliation': 'Save Affiliation',
  'Failed to add payment. Please try again.': 'Failed to add payment. Please try again.',
  'You have items in your invoice. Please generate the invoice first or remove all items before switching invoice type.': 'You have items in your invoice. Please generate the invoice first or remove all items before switching invoice type.',
  'Note: You cannot mix products and programs in a single invoice': 'Note: You cannot mix products and programs in a single invoice',
  'Override with Custom Discount': 'Override with Custom Discount',
  'Custom Discount Amount': 'Custom Discount Amount',
  "This will override customer's program discount slab. Items will be shown at MRP.": "This will override customer's program discount slab. Items will be shown at MRP.",
  'Include Shipping Charges': 'Include Shipping Charges',
  'Shipping Charges': 'Shipping Charges',
  'Shipping charges cannot exceed ₹300': 'Shipping charges cannot exceed ₹300',
  'Enter shipping charges (max ₹300)': 'Enter shipping charges (max ₹300)',
  'Maximum shipping charges allowed: ₹300. GST will be calculated at 18% (9% CGST + 9% SGST).': 'Maximum shipping charges allowed: ₹300. GST will be calculated at 18% (9% CGST + 9% SGST).',
  'off': 'off',
  'Basic (0% off)': 'Basic (0% off)',
  'Basic (MRP pricing)': 'Basic (MRP pricing)',
  'Select {item}': 'Select {item}',
  'Search {items}...': 'Search {items}...',
  'No {items} available': 'No {items} available',
  'No {items} found': 'No {items} found',
  'products': 'products',
  'programs': 'programs',
  'Basic (MRP)': 'Basic (MRP)',
  'Fixed Price (No Discount)': 'Fixed Price (No Discount)',
  'Basic (0%)': 'Basic (0%)',
  'Add Item': 'Add Item',
  'Cashback Wallet': 'Cashback Wallet',
  'Available Balance': 'Available Balance',
  'Modify Cashback': 'Modify Cashback',
  'This amount will be deducted from your cashback balance and applied as discount to the invoice.': 'This amount will be deducted from your cashback balance and applied as discount to the invoice.',
  'Subtotal (Before {type})': 'Subtotal (Before {type})',
  'Subtotal (After {type})': 'Subtotal (After {type})',
  'Custom Discount': 'Custom Discount',
  'Cashback': 'Cashback',
  'CGST ({rate}%)': 'CGST ({rate}%)',
  'SGST ({rate}%)': 'SGST ({rate}%)',
  'Program/Product Discount': 'Program/Product Discount',
  "Great! You're saving ₹{amount} with cashback discount. GST has been recalculated on the reduced amount.": "Great! You're saving ₹{amount} with cashback discount. GST has been recalculated on the reduced amount.",
  'e.g., Monthly program fee': 'e.g., Monthly program fee',
  'Full Payment': 'Full Payment',
  'Partial Payment': 'Partial Payment',
  'No Payment': 'No Payment',
  'Select Mode': 'Select Mode',
  'Overdue': 'Overdue',
  'Cancelled': 'Cancelled',
  'Additional notes...': 'Additional notes...',
  'Invoice Details': 'Invoice Details',
  'Already Paid': 'Already Paid',
  'Remaining': 'Remaining',
  'Max: ₹{amount}': 'Max: ₹{amount}',
  'Payment reference, transaction ID, etc.': 'Payment reference, transaction ID, etc.',
  'Failed to load coaches. Please try again.': 'Failed to load coaches. Please try again.',
  'Please select a coach': 'Please select a coach',
  'Coach requested club change for customer': 'Coach requested club change for customer',
  'Failed to submit request. Please try again.': 'Failed to submit request. Please try again.',
  'Club Change Request Submitted!': 'Club Change Request Submitted!',
  'Your request has been sent to the Upline Tab Team for approval.': 'Your request has been sent to the Upline Tab Team for approval.',
  'Request Club Change': 'Request Club Change',
  'Club Change Request for {name}': 'Club Change Request for {name}',
  'This request will be sent to the Upline Tab Team for approval. Once approved:': 'This request will be sent to the Upline Tab Team for approval. Once approved:',
  "Customer's coach will be changed to the selected coach": "Customer's coach will be changed to the selected coach",
  "Customer will be moved under the new coach's hierarchy": "Customer will be moved under the new coach's hierarchy",
  "Customer's access and programs will remain the same": "Customer's access and programs will remain the same",
  'Current Coach': 'Current Coach',
  'Your current coach': 'Your current coach',
  'Select New Coach': 'Select New Coach',
  'Loading coaches...': 'Loading coaches...',
  'Select a coach': 'Select a coach',
  'Reason for Change (Optional)': 'Reason for Change (Optional)',
  'This request requires approval from the Upline Tab Team. You will be notified once your request is reviewed.': 'This request requires approval from the Upline Tab Team. You will be notified once your request is reviewed.',
  'Submitting...': 'Submitting...',
  'Submit Request': 'Submit Request',
  'Conversion Request Submitted!': 'Conversion Request Submitted!',
  'Transition From Coach to Customer': 'Transition From Coach to Customer',
  'Your role will be changed from Coach to Customer': 'Your role will be changed from Coach to Customer',
  'You will lose access to coach features and tools': 'You will lose access to coach features and tools',
  'Your immediate customers will be moved to your parent coach': 'Your immediate customers will be moved to your parent coach',
  'You will become a customer under your parent coach': 'You will become a customer under your parent coach',
  'This action can be reversed with another promotion request': 'This action can be reversed with another promotion request',
  'This request requires approval from the Upline Tab Team. You will be notified once your request is reviewed. This action will significantly change your account permissions.': 'This request requires approval from the Upline Tab Team. You will be notified once your request is reviewed. This action will significantly change your account permissions.',
  'Please enter a valid cashback amount': 'Please enter a valid cashback amount',
  'Amount cannot exceed your cashback balance of ₹{amount}': 'Amount cannot exceed your cashback balance of ₹{amount}',
  'Amount cannot exceed current subtotal of ₹{amount}': 'Amount cannot exceed current subtotal of ₹{amount}',
  'Apply Cashback Discount': 'Apply Cashback Discount',
  'Available Cashback Balance': 'Available Cashback Balance',
  'Current Invoice Subtotal': 'Current Invoice Subtotal',
  'Maximum cashback you can apply': 'Maximum cashback you can apply',
  'Cashback Amount to Apply': 'Cashback Amount to Apply',
  'Enter amount between ₹0.01 and ₹{amount}': 'Enter amount between ₹0.01 and ₹{amount}',
  'How it works': 'How it works',
  'Cashback is applied as a discount to the invoice subtotal': 'Cashback is applied as a discount to the invoice subtotal',
  'This cashback will be deducted from your available balance': 'This cashback will be deducted from your available balance',
  'You can modify or remove the cashback before generating the invoice': 'You can modify or remove the cashback before generating the invoice',
  'Clear Cashback': 'Clear Cashback',
  'Apply Cashback': 'Apply Cashback',
  'Promote Customer to Coach': 'Promote Customer to Coach',
  'Important': 'Important',
  'Promoting this customer to coach will': 'Promoting this customer to coach will',
  'Change their role from Customer to Coach': 'Change their role from Customer to Coach',
  'Grant them access to coach features': 'Grant them access to coach features',
  'Allow them to manage their own customers': 'Allow them to manage their own customers',
  'This action cannot be easily undone': 'This action cannot be easily undone',
  'Are you sure you want to send a promotion request for {name} to become a coach?': 'Are you sure you want to send a promotion request for {name} to become a coach?',
  'What happens next': 'What happens next',
  'Upline Tab Team will receive an email notification': 'Upline Tab Team will receive an email notification',
  'They will also see a notification in their dashboard': 'They will also see a notification in their dashboard',
  'An approver will review and either approve or reject the request': 'An approver will review and either approve or reject the request',
  'You will be notified of the decision': 'You will be notified of the decision',
  'If approved, all customers referred by {name} will become your direct customers': 'If approved, all customers referred by {name} will become your direct customers',
  'Promoting...': 'Promoting...',
  'Promote to Coach': 'Promote to Coach',
  'Assign Program to {name}': 'Assign Program to {name}',
  'Select Program': 'Select Program',
  'Showing {type} programs only': 'Showing {type} programs only',
  'Comments': 'Comments',
  'Additional comments about program assignment...': 'Additional comments about program assignment...',
  'Assigning...': 'Assigning...',
  'Assign Now': 'Assign Now',
  'Balance Volume Points': 'Balance Volume Points',
  'Reason for Stopping Program': 'Reason for Stopping Program',
  'No attendance records found for this program period.': 'No attendance records found for this program period.',
  'Attendance Dates ({count} days)': 'Attendance Dates ({count} days)',
  "This will send the meal plan link to the customer's WhatsApp number.": "This will send the meal plan link to the customer's WhatsApp number.",
  'Program Information': 'Program Information',
  'Program Name': 'Program Name',
  'Program Code': 'Program Code',
  'Assigned Date': 'Assigned Date',
  'Balance Points': 'Balance Points',
  'Assignment Comments': 'Assignment Comments',
  'Program Stop Reason': 'Program Stop Reason',
  'Stopped on': 'Stopped on',
  'Program Statistics': 'Program Statistics',
  'Total Duration': 'Total Duration',
  'Attendance Rate': 'Attendance Rate',
  'Points Utilization': 'Points Utilization',
  'Days Remaining': 'Days Remaining',
  'Program Completed': 'Program Completed',
  'Program Expired': 'Program Expired',
  '{count} days': '{count} days',
  'Company Information': 'Company Information',
  'GSTIN': 'GSTIN',
  'FSSAI': 'FSSAI',
  'Invoice Date': 'Invoice Date',
  'Bill To': 'Bill To',
  'Discount Plan': 'Discount Plan',
  'Invoice Type': 'Invoice Type',
  'Program Invoice (18% GST)': 'Program Invoice (18% GST)',
  'Product Invoice (5% GST)': 'Product Invoice (5% GST)',
  'Add Line Items': 'Add Line Items',
  'Quantity': 'Quantity',
  'Discount Applied': 'Discount Applied',
  'Invoice Items': 'Invoice Items',
  'Item': 'Item',
  'Qty': 'Qty',
  'MRP': 'MRP',
  'Discounted Price': 'Discounted Price',
  'Cashback Applied': 'Cashback Applied',
  'Invoice Calculations': 'Invoice Calculations',
  'Custom Discount Applied': 'Custom Discount Applied',
  'Shipping (Base)': 'Shipping (Base)',
  'Shipping CGST (9%)': 'Shipping CGST (9%)',
  'Shipping SGST (9%)': 'Shipping SGST (9%)',
  'Total Shipping': 'Total Shipping',
  'Total Savings': 'Total Savings',
  'Final Amount': 'Final Amount',
  'Current Role': 'Current Role',
  'Code': 'Code',
  'Duration': 'Duration',
  'to': 'to',
  'Loading attendance data...': 'Loading attendance data...',
  'Meal Plan Name': 'Meal Plan Name',
  'Weight Category': 'Weight Category',
  'Food Preference': 'Food Preference',
  'Created Date': 'Created Date',
  'Share via WhatsApp': 'Share via WhatsApp',
  'Delete Meal Plan': 'Delete Meal Plan',
  'Weight (kg)': 'Weight (kg)',
  'Visceral Fat': 'Visceral Fat',
  'TSF': 'TSF',
  'Total Fat (%)': 'Total Fat (%)',
  'Meta Age': 'Meta Age',
  'BMI': 'BMI',
  'BMR': 'BMR',
  'Skeletal Muscle (%)': 'Skeletal Muscle (%)',
  'Ideal Values': 'Ideal Values',
  'Edit Reading': 'Edit Reading',
  'Delete Reading': 'Delete Reading',
  'Invoice #': 'Invoice #',
  'Total Amount': 'Total Amount',
  'Payment Info': 'Payment Info',
  'Due Date': 'Due Date',
  '{count} payment(s) made': '{count} payment(s) made',
  'Paid': 'Paid',
  'Total Paid': 'Total Paid',
  'Balance': 'Balance',
  'Last': 'Last',
  'Mode': 'Mode',
  'Add Partial Payment': 'Add Partial Payment',
  'Edit Invoice': 'Edit Invoice',
  'Delete Invoice': 'Delete Invoice',
  'Cancel Invoice': 'Cancel Invoice',
  'Are you sure you want to cancel this invoice?': 'Are you sure you want to cancel this invoice?',
  'Failed to cancel invoice. Please try again.': 'Failed to cancel invoice. Please try again.',
  'Report Date': 'Report Date',
  'Generated By': 'Generated By',
  'File Size': 'File Size',
  'Delete Report': 'Delete Report',
  'Volume Points': 'Volume Points',
  'Days Attended': 'Days Attended',
  'Assigned By': 'Assigned By',
  'Consumption / Total': 'Consumption / Total',
  'Days Present': 'Days Present',
  'View Program Details': 'View Program Details',
  'View Attendance': 'View Attendance',
  'Stop Program': 'Stop Program',
  'Stop': 'Stop',
  'Delete Program': 'Delete Program',
  'Available Templates': 'Available Templates',
  'Meal Plan Details': 'Meal Plan Details',
  'Creating...': 'Creating...',
  'Create Meal Plan': 'Create Meal Plan',
  'Share Meal Plan via WhatsApp': 'Share Meal Plan via WhatsApp',
  'Club': 'Club',
  'Company': 'Company',
  'City': 'City',
  'State': 'State',
  'Pincode': 'Pincode',
  'Payment Date': 'Payment Date',
  'Payment Mode': 'Payment Mode',
  'Payment Reference / Notes': 'Payment Reference / Notes',
  'Amount Paid': 'Amount Paid',
  'Add Payment': 'Add Payment',
  'Adding...': 'Adding...',
  'Cash': 'Cash',
  'Card': 'Card',
  'Bank Transfer': 'Bank Transfer',
  'Cheque': 'Cheque',
  'Net Banking': 'Net Banking',
  'Profile': 'Profile',
  'Company Settings': 'Company Settings',
  'Attendance': 'Attendance',
  'Attendance Marked': 'Attendance Marked',
  'Yet To Mark Attendance': 'Yet To Mark Attendance',
  'Loading settings...': 'Loading settings...',
  'Loading...': 'Loading...',
  'Please wait...': 'Please wait...',
  'View': 'View',
  'Download': 'Download',
  'Download PDF': 'Download PDF',
  'Download Document': 'Download Document',
  'Watch Video': 'Watch Video',
  'Open Meal Plan': 'Open Meal Plan',
  'Company Name': 'Company Name',
  'Phone Number': 'Phone Number',
  'Address Line 1': 'Address Line 1',
  'Address Line 2': 'Address Line 2',
  'GSTIN Number': 'GSTIN Number',
  'FSSAI Number': 'FSSAI Number',
  'Company Level': 'Company Level',
  'Herbalife Level': 'Herbalife Level',
  'Company Logo': 'Company Logo',
  'Current Logo': 'Current Logo',
  'Logo Preview': 'Logo Preview',
  'Delete Logo': 'Delete Logo',
  'Complete Setup & Continue': 'Complete Setup & Continue',
  'Save Company Information': 'Save Company Information',
  'Club Affiliation': 'Club Affiliation',
  'Select Affiliation': 'Select Affiliation',
  'Loading today\'s attendance...': 'Loading today\'s attendance...',
  'Marked At:': 'Marked At:',
  'My Health Library': 'My Health Library',
  'My Health Reports': 'My Health Reports',
  'My Programs': 'My Programs',
  'My Cashback Wallet': 'My Cashback Wallet',
  'My Meal Plans': 'My Meal Plans',
  'Add Health Reading': 'Add Health Reading',
  'Document': 'Document',
  'Report Date': 'Report Date',
  'Generated By': 'Generated By',
  'File Size': 'File Size',
  'Meal Plan Name': 'Meal Plan Name',
  'Weight Category': 'Weight Category',
  'Food Preference': 'Food Preference',
  'Created Date': 'Created Date',
  'Assigned By': 'Assigned By',
  'Volume Points': 'Volume Points',
  'Days Attended': 'Days Attended',
  'Product': 'Product',
  'Products': 'Products',
  'Search leads...': 'Search leads...',
  'Search products...': 'Search products...',
  'Search affiliated customers...': 'Search affiliated customers...',
  'Search by name, email, type or gender': 'Search by name, email, type or gender',
  'Enter username': 'Enter username',
  'Enter phone number': 'Enter phone number',
  'No data found.': 'No data found.',
  'No records found.': 'No records found.',
  'Back to Challenges': 'Back to Challenges',
  'Challenge not found.': 'Challenge not found.',
  'Add Users to Challenge': 'Add Users to Challenge',
  'Search and select referrer...': 'Search and select referrer...',
  'Additional notes about the lead...': 'Additional notes about the lead...',
  'e.g., Mumbai, Maharashtra': 'e.g., Mumbai, Maharashtra',
  'e.g., 75.5': 'e.g., 75.5',
  'e.g., 175.5': 'e.g., 175.5',
  'Auto-filled from DOB': 'Auto-filled from DOB',
  'e.g., STK001': 'e.g., STK001',
  'e.g., Protein Powder': 'e.g., Protein Powder',
  'e.g., 25.50': 'e.g., 25.50',
  'e.g., 2500.00': 'e.g., 2500.00',
  'e.g., 2250.00': 'e.g., 2250.00',
  'e.g., 2000.00': 'e.g., 2000.00',
  'Inventory Management': 'Inventory Management',
  'Upload E-invoices and track stock': 'Upload E-invoices and track stock',
  'Track inward stock from E-invoices or manual entries, then mark barcodes outward as stock leaves.': 'Track inward stock from E-invoices or manual entries, then mark barcodes outward as stock leaves.',
  'Current stock': 'Current stock',
  '{count} product types': '{count} product types',
  'Upload E-invoice PDF': 'Upload E-invoice PDF',
  'PDF file': 'PDF file',
  'Uploading...': 'Uploading...',
  'Upload and import': 'Upload and import',
  'Manual inward entry': 'Manual inward entry',
  'SKU': 'SKU',
  'Product name': 'Product name',
  'Barcodes': 'Barcodes',
  'One per line or comma separated. Leave blank to create manual stock units.': 'One per line or comma separated. Leave blank to create manual stock units.',
  'Add inward stock': 'Add inward stock',
  'Inventory': 'Inventory',
  'Search by product name or SKU': 'Search by product name or SKU',
  'Loading inventory...': 'Loading inventory...',
  'No stock found.': 'No stock found.',
  'Details': 'Details',
  'Uploaded E-invoices': 'Uploaded E-invoices',
  'No E-invoices uploaded yet.': 'No E-invoices uploaded yet.',
  'File': 'File',
  'Imported': 'Imported',
  'Page': 'Page',
  'First matched page': 'First matched page',
  'Uploaded at': 'Uploaded at',
  '{items} items, {barcodes} barcodes': '{items} items, {barcodes} barcodes',
  'SKU {sku} | {count} in stock': 'SKU {sku} | {count} in stock',
  'Loading barcodes...': 'Loading barcodes...',
  'No active barcodes remain for this item.': 'No active barcodes remain for this item.',
  'Barcode': 'Barcode',
  'Source': 'Source',
  'Inward at': 'Inward at',
  'E-invoice': 'E-invoice',
  'Manual': 'Manual',
  'Mark outward': 'Mark outward',
  'Confirm outward entry': 'Confirm outward entry',
  'This will reduce stock by 1 and keep the barcode record for compliance.': 'This will reduce stock by 1 and keep the barcode record for compliance.',
  'SKU {sku}': 'SKU {sku}',
  'Barcode {barcode}': 'Barcode {barcode}',
  'Confirm outward': 'Confirm outward',
  'In stock barcodes': 'In stock barcodes',
  'Outward entries': 'Outward entries',
  'No outward entries recorded for this item.': 'No outward entries recorded for this item.',
  'E-invoice outward entries': 'E-invoice outward entries',
  'Loading outward entries...': 'Loading outward entries...',
  'No outward entries recorded for this E-invoice.': 'No outward entries recorded for this E-invoice.',
  'Outward at': 'Outward at',
  'Reason': 'Reason',
  'Outward reason': 'Outward reason',
  'Add an optional comment for this outward entry.': 'Add an optional comment for this outward entry.',
  'Delete E-invoice': 'Delete E-invoice',
  'This will delete all entries from inventory for the selected E-invoice. The file will also be removed from S3.': 'This will delete all entries from inventory for the selected E-invoice. The file will also be removed from S3.',
  'E-invoice deleted. Imported inventory entries were removed.': 'E-invoice deleted. Imported inventory entries were removed.',
  'Unable to delete this E-invoice.': 'Unable to delete this E-invoice.',
  'Unable to load inventory right now.': 'Unable to load inventory right now.',
  'Choose a PDF E-invoice before uploading.': 'Choose a PDF E-invoice before uploading.',
  'E-invoice uploaded. {count} inward entries imported.': 'E-invoice uploaded. {count} inward entries imported.',
  'Unable to upload and parse this PDF.': 'Unable to upload and parse this PDF.',
  'Manual inward entries added.': 'Manual inward entries added.',
  'Unable to save manual inward entries.': 'Unable to save manual inward entries.',
  'Unable to load barcode details.': 'Unable to load barcode details.',
  'Outward entry marked. Stock reduced by 1.': 'Outward entry marked. Stock reduced by 1.',
  'Unable to mark this barcode outward.': 'Unable to mark this barcode outward.',
  'Unable to load E-invoice outward entries.': 'Unable to load E-invoice outward entries.',
  'Paste QR code URL or UUID here': 'Paste QR code URL or UUID here',
  'Track inward and outward stock with customer-level history.': 'Track inward and outward stock with customer-level history.',
  'Current Inventory': 'Current Inventory',
  'Outward Stock': 'Outward Stock',
  'Outward Stock History': 'Outward Stock History',
  'Review stock issued to customers and counter consumption.': 'Review stock issued to customers and counter consumption.',
  'Unable to load outward history.': 'Unable to load outward history.',
  'Unable to search customers.': 'Unable to search customers.',
  'Unable to search inventory.': 'Unable to search inventory.',
  'Counter consumption': 'Counter consumption',
  'Maps to your logged-in account for club consumption.': 'Maps to your logged-in account for club consumption.',
  'Search direct or affiliated customers': 'Search direct or affiliated customers',
  'Select a customer or Counter consumption.': 'Select a customer or Counter consumption.',
  'Add at least one inventory item.': 'Add at least one inventory item.',
  'Outward stock recorded successfully.': 'Outward stock recorded successfully.',
  'Unable to record outward stock.': 'Unable to record outward stock.',
  'No outward transactions found for this date range.': 'No outward transactions found for this date range.',
  'Club use': 'Club use',
  'Create Outward Stock': 'Create Outward Stock',
  'Choose a recipient and add one or more inventory items.': 'Choose a recipient and add one or more inventory items.',
  'Recipient': 'Recipient',
  'Add inventory items': 'Add inventory items',
  'available': 'available',
  'Confirm Outward Stock': 'Confirm Outward Stock',
  'Outward Transaction Details': 'Outward Transaction Details',
  'This will delete imported inventory entries and the uploaded file.': 'This will delete imported inventory entries and the uploaded file.',
  'Edit Product Settlement': 'Edit Product Settlement',
  'Correct the products, quantities, due date, or comments.': 'Correct the products, quantities, due date, or comments.',
  'Update Settlement': 'Update Settlement',
  'Unable to update product settlement.': 'Unable to update product settlement.',
  'Unable to delete product settlement.': 'Unable to delete product settlement.',
  'Deleting this settlement will also delete its return history. Continue?': 'Deleting this settlement will also delete its return history. Continue?',
  'Products with recorded returns cannot be removed.': 'Products with recorded returns cannot be removed.',
  'Daily Log Monitoring': 'Daily Log Monitoring',
  'Submitted today': 'Submitted today',
  "Today's Daily Log Monitoring": "Today's Daily Log Monitoring",
  'Active Online and Club customers': 'Active Online and Club customers',
  'Active Customers': 'Active Customers',
  'Submitted': 'Submitted',
  'Not Submitted': 'Not Submitted',
  'Daily log submitted': 'Daily log submitted',
  'Customers below 65% are highlighted for attention.': 'Customers below 65% are highlighted for attention.',
  'No customers have submitted a daily log today.': 'No customers have submitted a daily log today.',
  'Daily log not submitted': 'Daily log not submitted',
  'Every active customer has submitted a daily log today.': 'Every active customer has submitted a daily log today.',
  'View Daily Log': 'View Daily Log',
  'Not submitted': 'Not submitted',
  'Loading daily log status...': 'Loading daily log status...',
  'Unable to load daily log monitoring.': 'Unable to load daily log monitoring.',
  "Yesterday's log submitted": "Yesterday's log submitted",
  "Checking yesterday's log dated {date}": "Checking yesterday's log dated {date}",
  "No customers have submitted yesterday's daily log.": "No customers have submitted yesterday's daily log.",
  "Every active customer has submitted yesterday's daily log.": "Every active customer has submitted yesterday's daily log.",
};

export default en;
